import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

export const useCareerCompassI18n = () => {
  const { t } = useI18n();
  const store = useStore();
  const lang = computed(() => store.getters.getCurrentLanguage || localStorage.getItem("currentLanguage") || "en");
  const tc = (key: string, params: Record<string, unknown> = {}) => t(`${lang.value}.career_compass.${key}`, params);
  return { lang, tc };
};
